/**
 * Configuration-based logger. Only outputs when:
 * - Vite dev mode (import.meta.env.DEV === true), or
 * - VITE_ENABLE_CONSOLE_LOG is set to 'true' (e.g. in .env for production debugging).
 *
 * In production builds, logs are off unless you set in .env:
 *   VITE_ENABLE_CONSOLE_LOG=true
 */


const enabled = import.meta.env.VITE_ENABLE_CONSOLE_LOG === "true"? true : false;

export function log(...args) {
  if (enabled) console.log(...args);
}

export function warn(...args) {
  if (enabled) console.warn(...args);
}

export function error(...args) {
  if (enabled) console.error(...args);
}

export function debug(...args) {
  if (enabled) console.debug(...args);
}

export function info(...args) {
  if (enabled) console.info(...args);
}
